import React, { useEffect } from 'react';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { useTranslation } from 'react-i18next';
import { DOCUMENT_LIBRARY_HEAD_CELLS } from '../../../../utils/constans/tableHeads/documentLibraryTableHead';
import {
    DocumentData,
    DocumentHeadCellContent,
    SortParams,
} from '../../../../models/DocumentLibrary';
import { DocumentLibraryTableRow } from '../../../document-library/DocumentLibraryTableRow';
import { SWRTable } from '../../../shared/Table/SWRTable';
import useDocumentLibrarySWR from '../../../../hooks/dokumentLibrary/useDocumentLibrarySWR';
import { Box } from '@mui/material';
import { PaginateOptions, TableSettings } from '../../../../models/SWRTable';

export const DocumentLibrary = () => {
    const { t } = useTranslation('documentLibrary');
    const [page, setPage] = React.useState<number>(1);
    const [rowsPerPage, setRowsPerPage] = React.useState<number>(25);
    const [search, setSearch] = React.useState<string>('');
    const [maxItems, setMaxItems] = React.useState<number>(0);
    const [column, setColumn] =
        React.useState<keyof DocumentHeadCellContent>('last_modified');
    const [order, setOrder] = React.useState<'asc' | 'desc'>('desc');

    const { documents, isLoading, isError } = useDocumentLibrarySWR({
        page: page,
        size: rowsPerPage,
        search: search,
        column: column,
        order: order,
    });

    useEffect(() => {
        if (!isLoading && documents) {
            setMaxItems(documents.max_item);
        }
    }, [isLoading, documents]);

    const defaultPaginateOptions: PaginateOptions = {
        lazyPaginate: true,
        size: rowsPerPage,
        page: page - 1,
        search: search,
    };

    const tableSettings: TableSettings<DocumentHeadCellContent> = {
        tableHeadSettings: {
            translateNs: 'documentLibrary',
            translatePrefix: 'TABLE_HEAD',
            selectable: false,
            headContent: DOCUMENT_LIBRARY_HEAD_CELLS,
        },
        tableToolbarSettings: {
            translateNs: 'documentLibrary',
            translatePrefix: 'TABLE_TOOLBAR',
        },
    };

    const handleChange = (size: number, page: number, filter: string): void => {
        switch (true) {
            case search != filter:
                setPage(1);
                setSearch(filter);
                break;
            case rowsPerPage != size:
                setPage(1);
                setRowsPerPage(size);
                break;
            default:
                setPage(page + 1);
        }
    };

    const handleShort = (props: SortParams<DocumentHeadCellContent>): void => {
        setColumn(props.property);
        setOrder(!props.isAsc ? 'asc' : 'desc');
    };

    return (
        <>
            <PageTitle>{t('PAGE_TITLE')}</PageTitle>
            {isError && <Box>{t('LOADING_ERROR')}</Box>}
            <SWRTable<DocumentData, DocumentHeadCellContent>
                listItems={documents ? documents.documents : []}
                totalNumber={maxItems}
                component={DocumentLibraryTableRow}
                handleChange={handleChange}
                paginateOptions={defaultPaginateOptions}
                tableSettings={tableSettings}
                isLoading={isLoading}
                handleShort={handleShort}
            />
        </>
    );
};
